import MainNavigationBar from "./MainNavigationBar.vue";

export default MainNavigationBar;
